module.exports = __webpack_public_path__ + "img/IMG_9543_L_BlackMatted_MockedUp.8ea2918c.jpg";